import { LOGIN_REDIRECT_QUERY_KEY } from './auth'

/** Carries an affiliate's referral code from the link to the order. */
export const AFFILIATE_REF_COOKIE = 'mw_affiliate_ref'

/** How long a click keeps counting. The last click wins. */
export const AFFILIATE_REF_MAX_AGE_SECONDS = 60 * 60 * 24 * 7

const REF_QUERY_KEY = 'ref'

/**
 * `redirect` hops worth following. One is every chain the console builds itself
 * (the sign-in wall, and the sign-in / sign-up links that carry its destination
 * on); the second is slack. Bounded so a hand-built URL cannot recurse forever.
 */
const MAX_REDIRECT_HOPS = 2

/**
 * The referral code a URL carries: its own `ref`, or the `ref` of the page its
 * `redirect` leads back to.
 *
 * The second half is the one that matters. The link an affiliate shares is the
 * console's front door, and a signed-out visitor is sent to
 * `/login?redirect=/?ref=…` before anything renders — so on the page they
 * actually see, `ref` is no longer a parameter of its own. Reading only the top
 * level attributed nobody who arrived without a session.
 */
export function referralCodeFromUrl(url: string): string | null {
  return readReferralCode(url, MAX_REDIRECT_HOPS)
}

function readReferralCode(url: string, hopsLeft: number): string | null {
  let params: URLSearchParams
  try {
    params = new URL(url, 'http://localhost').searchParams
  } catch {
    return null
  }
  const code = params.get(REF_QUERY_KEY)?.trim()
  if (code) return code
  const redirect = params.get(LOGIN_REDIRECT_QUERY_KEY)
  return redirect && hopsLeft > 0 ? readReferralCode(redirect, hopsLeft - 1) : null
}
